import type * as store from '@attain-apps/fe/web/main/lib/store'

/** Consumer-owned request and empty-state snapshot. */
export interface Status {
  readonly empty?: Status.Message
  readonly error?: Status.Message
  readonly loading?: boolean
  readonly onRetry?: () => void
}
export namespace Status {
  /** Content shown for an empty or failed table state. */
  export interface Message {
    readonly toolLabel?: string
    readonly description?: string
    readonly title?: string
  }

  /** Metadata used to distinguish an explicit table retry from other loads. */
  export namespace Refresh {
    const TRACE_KEY = 'ds.table.refresh'
    const TRACE_VALUE = true

    /** Options attached to collection loads initiated by the retry action. */
    export const traceOptions = {
      traceStash: {
        [TRACE_KEY]: TRACE_VALUE,
      },
    } as const

    /** Whether an action originated from the canonical table retry control. */
    export function isTriggeredAction(
      action: Pick<store.actions.Action, 'traceStash'>,
    ): boolean {
      return action.traceStash?.[TRACE_KEY] === TRACE_VALUE
    }
  }
}
